import React from "react";
import "./AcademicCalendar.css";

const AcademicCalendar = ({ schoolYear, startDate, endDate, schoolDays, events }) => {
  const schoolDaysSet = new Set(
    schoolDays.split(",").map((day) => day.trim()) // Split by commas and trim spaces
  );
  const start = new Date(startDate);
  const end = new Date(endDate);

  const generateCalendar = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let runningSchoolDayCount = 0; // Initialize school day count
    const calendar = [];

    for (
      let year = start.getFullYear(), month = start.getMonth();
      year <= end.getFullYear() && (year < end.getFullYear() || month <= end.getMonth());
      month++
    ) {
      if (month === 12) {
        month = 0;
        year++;
      }

      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      const daysInMonth = Array.from({ length: lastDay.getDate() }, (_, i) => new Date(year, month, i + 1));

      // Render days outside the loop to avoid closures referencing the loop variable
      const renderDaysInMonth = (days, initialSchoolDayCount) => {
        let currentSchoolDayCount = initialSchoolDayCount;

        return days.map((day, index) => {
          const dayString = day.toISOString().split("T")[0];
          const isSchoolDay = schoolDaysSet.has(dayString);
          const event = events.find((e) => e.date === dayString);

          if (isSchoolDay) {
            currentSchoolDayCount++;
          }

          return (
            <div
              key={day}
              className={`calendar-day ${isSchoolDay ? "school-day" : ""} ${
                event ? "event-day" : ""
              } ${
                Math.floor((firstDay.getDay() + index) / 7) % 2 === 0
                  ? "even-week"
                  : "odd-week"
              }`}
            >
              <div className="day-number">{day.getDate()}</div>
              {isSchoolDay && (
                <div className="school-day-count">Day {currentSchoolDayCount}</div>
              )}
              {event && (
                <a href={event.link} className="event-label" title={event.label}>
                  {event.label}
                </a>
              )}
            </div>
          );
        });
      };

      const renderedDays = renderDaysInMonth(daysInMonth, runningSchoolDayCount);
      runningSchoolDayCount += daysInMonth.filter((day) =>
        schoolDaysSet.has(day.toISOString().split("T")[0])
      ).length; // Update the school day count safely

      calendar.push(
        <div key={`${year}-${month}`} className="calendar-month">
          <h3>{`${months[month]} ${year}`}</h3>
          <div className="calendar-grid">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, i) => (
              <div key={i} className="calendar-day-header">
                {day}
              </div>
            ))}
            {Array(firstDay.getDay())
              .fill(null)
              .map((_, i) => (
                <div key={`empty-${i}`} className="calendar-day empty"></div>
              ))}
            {renderedDays}
          </div>
        </div>
      );
    }

    return calendar;
  };

  return (
    <div className="academic-calendar">
      <div className="calendar">{generateCalendar()}</div>
    </div>
  );
};

export default AcademicCalendar;
